import { Storage } from 'aws-amplify';

import { DEFAULT_FILE_PROTECTION_LEVEL } from './constants';

export const getImage = (fileKey: string, protectionLevel = DEFAULT_FILE_PROTECTION_LEVEL) => {
  return Storage.get(fileKey, { level: protectionLevel });
};
